import { render, staticRenderFns } from "./RejectionRemarksDialog.vue?vue&type=template&id=57eaa6ee"
import script from "./RejectionRemarksDialog.vue?vue&type=script&lang=js"
export * from "./RejectionRemarksDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports